module.exports = __webpack_public_path__ + "img/step-score-zh.213c0d87.webp";